import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c569da1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deduct-item-page" }
const _hoisted_2 = { class: "deduct-item-page__row-actions" }

import { computed, onMounted, reactive, ref, shallowRef } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete, Edit, Plus } from '@element-plus/icons-vue'
import {
  CrudDialog,
  CrudForm,
  CrudSearch,
  CrudTable
} from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import {
  createDeductItemTableColumns,
  deductItemFormItems,
  deductItemSearchItems
} from './deduct-item.config'
import type { DeductItemForm } from './deduct-item.config'
import {
  createDeductItem,
  deleteDeductItem,
  fetchDeductItemPage,
  updateDeductItem
} from './deduct-item.service'
import type {
  DeductItemFlow,
  DeductItemPayload,
  DeductItemRecord
} from './deduct-item.service'

type FormRef = InstanceType<typeof CrudForm>
type DialogMode = 'create' | 'edit'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeductItem',
  setup(__props) {

const canList = usePermission('deductItem', 'list')
const canCreate = usePermission('deductItem', 'create')
const canUpdate = usePermission('deductItem', 'update')
const canDelete = usePermission('deductItem', 'delete')
const deductItemTableColumns = createDeductItemTableColumns(
  canUpdate || canDelete
)

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh,
  refreshAfterDelete
} = usePagedCrud({
  createFilters: () => ({ flow: '' as DeductItemFlow | '', reason: '' }),
  fetchPage: fetchDeductItemPage
})

const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

const dialogVisible = ref(false)
const dialogMode = ref<DialogMode>('create')
const formRef = ref<FormRef>()
const editingItem = shallowRef<DeductItemRecord>()
const form = reactive<DeductItemForm>({ reason: '', flow: '', point: '' })

const dialogTitle = computed(() =>
  dialogMode.value === 'create' ? '新增积分扣除项' : '编辑积分扣除项'
)

const rules = {
  reason: { required: true, message: '原因是必传的', trigger: 'blur' },
  flow: { required: true, message: '流向是必选的', trigger: 'change' },
  point: { required: true, message: '积分数量是必传的', trigger: 'blur' }
}

function resetForm() {
  form.reason = ''
  form.flow = ''
  form.point = ''
}

function openCreateDialog() {
  dialogMode.value = 'create'
  editingItem.value = undefined
  resetForm()
  dialogVisible.value = true
}

function openEditDialog(row: DeductItemRecord) {
  dialogMode.value = 'edit'
  editingItem.value = row
  form.reason = row.reason
  form.flow = row.flow
  form.point = row.point
  dialogVisible.value = true
}

async function submitForm() {
  if (!(await formRef.value!.validate())) return false

  const payload: DeductItemPayload = {
    reason: form.reason,
    flow: form.flow as DeductItemFlow,
    point: form.point
  }

  if (dialogMode.value === 'create') {
    await createDeductItem(payload)
  } else {
    await updateDeductItem(editingItem.value!.id, payload)
  }
  return true
}

async function handleSubmitSuccess() {
  ElMessage.success(dialogMode.value === 'create' ? '新增成功' : '编辑成功')
  await refresh()
}

function handleSubmitError(cause: unknown) {
  ElMessage.error(cause instanceof Error ? cause.message : '操作失败')
}

const deletingId = ref<DeductItemRecord['id']>()

async function handleDelete(row: DeductItemRecord) {
  try {
    await ElMessageBox.confirm('确认删除此扣除项吗？', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
  } catch {
    return
  }

  deletingId.value = row.id
  try {
    await deleteDeductItem(row.id)
    ElMessage.success('删除成功')
    await refreshAfterDelete()
  } catch (cause) {
    ElMessage.error(cause instanceof Error ? cause.message : '删除失败')
  } finally {
    deletingId.value = undefined
  }
}

onMounted(() => {
  if (canList) load()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: _unref(deductItemSearchItems),
      loading: _unref(loading),
      onSearch: _unref(search),
      onReset: _unref(reset)
    }, null, 8, ["model", "items", "loading", "onSearch", "onReset"]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: _unref(deductItemTableColumns),
      onPageChange: _unref(changePage),
      onPageSizeChange: _unref(changePageSize),
      onRetry: _unref(refresh)
    }, {
      title: _withCtx(() => [
        _createTextVNode("积分扣除项列表")
      ]),
      actions: _withCtx(() => [
        (_unref(canCreate))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: openCreateDialog
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus), {
                  class: "deduct-item-page__button-icon",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" 新增 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      rowActions: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(canUpdate))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                onClick: ($event: any) => (openEditDialog(row))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Edit), {
                    class: "deduct-item-page__button-icon",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" 编辑 ")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(canDelete))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "text",
                loading: deletingId.value === row.id,
                disabled: deletingId.value !== undefined,
                onClick: ($event: any) => (handleDelete(row))
              }, {
                default: _withCtx(() => [
                  (deletingId.value !== row.id)
                    ? (_openBlock(), _createBlock(_unref(Delete), {
                        key: 0,
                        class: "deduct-item-page__button-icon",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" 删除 ")
                ]),
                _: 2
              }, 1032, ["loading", "disabled", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns", "onPageChange", "onPageSizeChange", "onRetry"]),
    _createVNode(_unref(CrudDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogTitle.value,
      submit: submitForm,
      onSuccess: handleSubmitSuccess,
      onSubmitError: handleSubmitError
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(CrudForm), {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          items: _unref(deductItemFormItems),
          rules: rules
        }, null, 8, ["model", "items"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})